// tokens.js
export const lightTokens = {
  color: {
    //basic    
    white: '#ffffff',
    lightgray: '#f9fafb',
    gray: '#999999',
    darkgray: '#555555',
    text: '#444444',
    background: '#ffffff',
    border: '#e3ebf6',
    //main
    primary: '#6c8f65',
    primaryDark: '#4d6d47',
    secondary: '#978470',
    secondaryDark: '#000000',
    highlight: '#FBB584',
    danger: '#D00202',
    //text
    title: '#5B6958',
    description: '#4e5968',
    //bg
    bgBody: '#ffffff',
    bgHeader: '#ffffff',
    bgSidebar: '#ffffff',
    bgPaper: '#f8f9fa',
    bgCard: '#ffffff',
  }
};

export const darkTokens = {
  color: {
    //basic    
    white: '#ffffff',
    lightgray: '#f9fafb',
    gray: '#999999',
    darkgray: '#555555',
    text: '#ffffff',
    background: '#444444',
    border: '#333333',
    //main
    primary: '#97b891',
    primaryDark: '#6c8f65',
    secondary: '#978470',
    secondaryDark: '#000000',
    highlight: '#FBB584',
    danger: '#D00202',
    //text
    title: '#b0bbae',
    description: '#b0bbae',
    //bg
    bgBody: '#121212',
    bgHeader: '#000000',
    bgSidebar: '#000000',
    bgPaper: '#000000',
    bgCard: '#000000',
  },
};